import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sun, Thermometer, BatteryCharging, Droplets, Cpu, Zap } from 'lucide-react';
import { SOLUTIONS } from '../mock';
import PartnerBanner from '../components/PartnerBanner';
import CTASection from '../components/CTASection';

const ICONS = { Sun, Thermometer, BatteryCharging, Droplets, Cpu, Zap };

export default function Solutions() {
  return (
    <div>
      <section className="pt-36 pb-16 bg-grad-hero relative overflow-hidden">
        <img src="/logos/logo-blue.png" alt="" aria-hidden="true" className="absolute -right-20 -top-10 w-[420px] opacity-[0.05]" />
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <p className="eyebrow">Nos solutions</p>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl mt-5 leading-[1.05] text-gray-900 max-w-4xl">Des solutions énergétiques <span className="italic-accent">clé en main.</span></h1>
          <p className="mt-6 text-gray-600 max-w-2xl leading-relaxed">Les solutions énergétiques de Suisse Energies Renouvelables allient performance, fiabilité et durabilité. Toutes les solutions sont minutieusement étudiées pour répondre à chaque profil de consommation et chaque besoin énergétique.</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {SOLUTIONS.map(s => {
            const Icon = ICONS[s.icon] || Sun;
            return (
              <Link to={`/solutions/${s.slug}`} key={s.slug} className="solution-card group relative bg-white rounded-2xl overflow-hidden border border-gray-200 flex flex-col">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <div className="absolute top-4 left-4 w-10 h-10 rounded-full bg-white flex items-center justify-center shadow"><Icon className="w-5 h-5 text-[#80b23f]" /></div>
                </div>
                <div className="p-6">
                  <span className="text-[10px] tracking-[0.18em] uppercase text-gray-500 font-semibold">{s.eyebrow}</span>
                  <h3 className="font-display text-2xl text-gray-900 mt-2 mb-2">{s.title}</h3>
                  <p className="text-sm text-gray-600 mb-4">{s.short}</p>
                  <span className="text-sm font-medium text-[#125082] inline-flex items-center gap-1 group-hover:gap-2 transition-all">Découvrir <ArrowRight className="w-4 h-4" /></span>
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      <PartnerBanner />
      <CTASection />
    </div>
  );
}
